import axios from "axios";
import apiInstance from "./api";
import { CreateTeamInput, Team } from "../types/model";

const API_URL = process.env.REACT_APP_API_URL;

export const getTeams = async (params: {
	sport?: string;
	series?: string;
	season?: string;
	leagueId?: string;
}) => {
	return apiInstance.get(`/teams`, { params });
};

export const getTeam = async (teamId: string) => {
	return apiInstance.get(`/teams/${teamId}`);
};

// export const getTeamBySportAndSeries = async (params) => {
// 	return apiInstance.get(`/teams/sport-series`, params);
// };

export const createTeam = async (teamData: CreateTeamInput) => {
	return apiInstance.post(`/teams`, teamData);
};

export const updateTeam = async (teamId: string, teamData: CreateTeamInput) => {
	return apiInstance.put(`/teams/${teamId}`, teamData);
};

export const deleteTeam = async (teamId: string) => {
	return apiInstance.delete(`/teams/${teamId}`);
};
